import { IteratorResultSlots } from '../../constants';
import { Helper } from '../Helper';
export class CreateIteratorResultHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitOp(node, 'NEWMAP');
        sb.emitOp(node, 'TUCK');
        sb.emitPushInt(node, IteratorResultSlots.done);
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'SETITEM');
        sb.emitOp(node, 'TUCK');
        sb.emitPushInt(node, IteratorResultSlots.value);
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'SETITEM');
        sb.emitHelper(node, options, sb.helpers.wrapIteratorResult);
    }
}

//# sourceMappingURL=CreateIteratorResultHelper.js.map
